import {
  Component,
  HostListener,
  AfterViewInit,
  OnInit,
} from '@angular/core';
import { Router, NavigationEnd, RouterOutlet } from '@angular/router';
import { filter } from 'rxjs/operators';
import { PubSubService } from '../sdk/services/core/pub-sub.service';
import { environment } from '../environments/environment';
import { DynamicScriptLoaderService } from './../sdk/services/custom/script-store';
import { clearChunkReloadFlag } from '../sdk/services/core/chunk-load-error.util';
import { JsonLdShimComponent } from './json-ld-shim/json-ld.component';
import { BlockUIModule } from 'ng-block-ui';

declare let ga: Function;

@Component({
  standalone: true,
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  imports: [RouterOutlet, JsonLdShimComponent, BlockUIModule],
})
export class AppComponent implements OnInit, AfterViewInit {
  showNavbar = false;
  schema = {
    "@context": "https://schema.org",
    "@graph": [
      {
        "@type": "Organization",
        "@id": "http://falaya.com/home/#organization",
        "name": "Falaya",
        "url": "http://falaya.com/home",
        "founder": "Barret Blondeau",
        "sameAs": [
          "https://www.facebook.com/FalayaRealEstate",
          "https://www.instagram.com/falayarealestate/",
          "https://www.linkedin.com/company/falaya",
          "https://twitter.com/FalayaRE",
          "https://www.youtube.com/channel/UC3ITu6Rby2u9LYyHiH-MJ0g"
        ],
        "address": {
          "@type": "PostalAddress",
          "addressLocality": "Baton Rouge",
          "addressRegion": "louisiana",
          "postalCode": "70808",
          "streetAddress": "4818 Tulane Dr"
        },
        "email": "support@falaya.com",
        "logo": {
          "@type": "ImageObject",
          "@id": "http://falaya.com/#logo",
          "inLanguage": "en-US",
          "url": "http://falaya.com/assets/images/unlockd-logo.png",
          "width": 96,
          "height": 24,
          "caption": "Falaya"
        },
        "image": {
          "@id": "http://falaya.com/#logo"
        }
      },
      {
        "@type": "WebSite",
        "@id": "http://falaya.com/#website",
        "url": "http://falaya.com/",
        "name": "falaya",
        "description": "Flat fee broker",
      
        "potentialAction": [
          {
            "@type": "SearchAction",
            "target": "http://falaya.com/{search_term_string}",
            "query-input": "required name=search_term_string"
          }
        ],
        "inLanguage": "en-US"
      },
      {
        "@context": "http://schema.org",
        "@id": "https://www.falaya.com/#webpage",
        "@type": "WebPage",
        "url": "https://www.falaya.com/",
        "name": "falaya"
    }
    ]
  }

  current_route = '';
  constructor(
    public router: Router,
    public pubSubService: PubSubService,
    private dynamicScriptLoaderService: DynamicScriptLoaderService,
  ) {
    router.events
      .pipe(filter((event) => event instanceof NavigationEnd))
      .subscribe(() => {
        const route = this.router.url;
        this.current_route = route;
        if (window['HubSpotConversations']) {
          this.handleHubspotChatButton(route);
        } else {
          window['hsConversationsOnReady'] = [
            () => {
              this.handleHubspotChatButton(route);
            },
          ];
        }

        if (
          route.includes('dashboard') ||
          route.includes('login') ||
          route.includes('admin') ||
          route.includes('video') ||
          route == '/listing-payment' ||
          route == '/404' ||
          route.includes('signup') ||
          route.includes('landingpage')||
          route.includes('guide')
        ) {
          this.showNavbar = false;
        } else {
          this.showNavbar = true;
        }
        const header = document
          .getElementsByClassName('ant-layout-content')
          .item(0);
        if (header) {
          header.scrollTop = 0;
          header.scrollIntoView();
        }
        if(ga){
          ga('set', 'page', route);
          ga('send', 'pageview');
        }
      });
  }
  topNavBarListener(){
    this.pubSubService.subscribe(event => {
      if (event.type === 'update_show_navbar') {
        this.showNavbar = event.data;
      }
    });
  }
  handleHubspotChatButton(route) {
    if (
      route == '/' ||
      route == '/home' ||
      route == '/buy' ||
      route == '/sell' ||
      route == '/pricing' ||
      route == '/about-us' ||
      route == '/comparison'
    ) {
      window['HubSpotConversations']?.widget?.load();
    } else {
      window['HubSpotConversations']?.widget?.remove();
    }
  }
  ngOnInit() {
    clearChunkReloadFlag();
    this.topNavBarListener();
  }
  ngAfterViewInit() {
    if(ga){
      ga('create', environment.ga_tracking_id, 'auto');
    }
    this.dynamicScriptLoaderService.loadLinkTag({
      href:"https://use.fontawesome.com/releases/v5.2.0/css/all.css",
      rel:"stylesheet",
      integrity:"sha384-hWVjflwFxL6sNzntih27bfxkr27PmbbK/iSvJ+a4+0owXq79v+lsFkW54bOGbiDQ",
      as:"font",
      crossOrigin:"anonymous",
      defer:true,
      async:true,
    });

    this.dynamicScriptLoaderService.loadGoogleTagNoScript();
    this.dynamicScriptLoaderService.loadGoogleTagHeadScript();
    this.dynamicScriptLoaderService.loadScriptTag({
      type:"text/javascript",
      id:"hs-script-loader",
      src:"//js.hs-scripts.com/7815375.js",
    });

    this.dynamicScriptLoaderService.loadScriptTag({
      src:"https://apis.google.com/js/platform.js",
      defer:true,
      async:true,
    });
  }
  @HostListener('window:click', ['$event'])
  handleKeyDown(event: MouseEvent) {
    if(ga){
      ga('set', 'page', this.router.url);
      ga('send', 'event');
    }
  }
}
